// extracted by mini-css-extract-plugin
export default {"screenXsMax":"(max-width: 768px)","actions":"styles_actions__F4ZU0"};